import React from 'react';
import { SimpleCard, CardSection } from '@/components/Cards';
import { MultiListTableProps } from './MultiListTable';
import theme from './MultiList.module.scss';

const MultiListCard: React.FC<MultiListTableProps> = ({
    striped,
    className,
    columns,
    sortByKey,
    setSortByAsc,
    setSortByKey,
    sortByAsc,
    data,
    onRowClick,
}) => {
    const autoWidth = 100 / columns.length;

    const renderCardRow = (row: any, index: number) => {
        return (
            <SimpleCard>
                {columns.map((c) => {
                    if (c._type === 'OptionsColumn')
                        return (
                            <CardSection className={theme.optionColumn} key={'optionColumn'} right width={`${autoWidth}%`} caption={c.header}>
                                {c._type === 'OptionsColumn' && c.renderFunction && c.renderFunction(row, index)}
                            </CardSection>
                        );
                    return (
                        <CardSection key={c.keyName} width={`${autoWidth}%`} caption={c.header}>
                            {c.renderFunction ? c.renderFunction(row[c.keyName], index) : row[c.keyName]}
                        </CardSection>
                    );
                })}
            </SimpleCard>
        );
    };
    return <>{data.map((row, i) => renderCardRow(row, i))}</>;
};

export default MultiListCard;
